/**
 * Filter key for the "Hide Test Account" toggle.
 *
 * The Accounts list filters on its own `isTestAccount` field; Invoices, Quotes,
 * and Contracts filter on the related account's flag, which the backend exposes
 * under the same `isTestAccount` key on each list endpoint. Centralized here so
 * the backend param name is a single-line change if it ever diverges.
 */
export const TEST_ACCOUNT_FILTER_KEY = 'isTestAccount';

/**
 * Toggle value sent to the API when "Hide Test Account" is enabled. Matches the
 * format the Accounts boolean filter already uses (EQUAL -> `isTestAccount=false`),
 * i.e. show only records whose account is not a test account.
 */
export const HIDE_TEST_ACCOUNT_TRUE_VALUE = 'false';

/** Toggle value when disabled — empty string omits the param entirely. */
export const HIDE_TEST_ACCOUNT_FALSE_VALUE = '';
